import React from 'react';
import T from 'prop-types';
import { useSelector } from 'react-redux';

import TotalNotAvailable from './TotalNotAvailable';
import Skeletons from '../Skeletons';

import { numberToHumanSummary } from '../../../../utils/formatter';

import { totalsSelector, totalsSettingsSelector } from '../../selectors';
import { initParams } from '../../configs';

const { permissions } = initParams;

const formatRevenue = (value) => `$${numberToHumanSummary(value)}`;

const Tile = ({ icon, label, value, valueClassName, showValue, blurVariant }) => (
  <div className="publisher_page_totals__tile">
    <i className={`publisher_page_totals__icon ${icon}`} />
    <p className={`publisher_page_totals__label ${valueClassName || ''}`}>{label}</p>
    <p className="publisher_page_totals__value">
      {showValue ? (
        <span className={valueClassName}>{value}</span>
      ) : (
        <TotalNotAvailable variant={blurVariant} />
      )}
    </p>
  </div>
);

Tile.propTypes = {
  icon: T.string.isRequired,
  label: T.string.isRequired,
  value: T.oneOfType([T.string, T.number]),
  valueClassName: T.string,
  showValue: T.bool.isRequired,
  blurVariant: T.oneOf(['blue', 'green', 'gray']).isRequired,
};

const WorldwideTotals = () => {
  const totals = useSelector(totalsSelector);
  const { loaded, pending } = useSelector(totalsSettingsSelector);

  if (pending || !loaded || !totals) {
    return (
      <section className="publisher_page_totals">
        <div className="publisher_page_totals__grid">
          {Skeletons.kpiTile}
          {Skeletons.kpiTile}
          {Skeletons.kpiTile}
          {Skeletons.kpiTile}
        </div>
      </section>
    );
  }

  return (
    <section className="publisher_page_totals">
      <div className="publisher_page_totals__grid">
        <Tile
          icon="hicon-download text-blue"
          label="Total Downloads:"
          value={numberToHumanSummary(totals.downloads)}
          valueClassName="text-blue"
          showValue={permissions.allowTotals}
          blurVariant="blue"
        />
        <Tile
          icon="hicon-dollar text-green"
          label="Total Revenue:"
          value={formatRevenue(totals.total_revenue)}
          valueClassName="text-green"
          showValue={permissions.allowTotals}
          blurVariant="green"
        />
        <Tile
          icon="hicon-dau text-quiet"
          label="Total Daily Active Users:"
          value={numberToHumanSummary(totals.dau)}
          showValue={permissions.allowUsageTotals}
          blurVariant="gray"
        />
        <Tile
          icon="hicon-mau text-quiet"
          label="Total Monthly Active Users:"
          value={numberToHumanSummary(totals.mau)}
          showValue={permissions.allowUsageTotals}
          blurVariant="gray"
        />
      </div>
    </section>
  );
};

export default WorldwideTotals;
